import { ProblemProgress } from '@yandex-int/k-common/typings';
import b from 'b_';
import { ProgressLine, Text } from 'platform-components';
import React from 'react';

// @ts-ignore
import COLORS from '../constants.scss';
import { STATS_THEME } from '../typings';

import ProgressChart from './stats__stats-progress-chart';

import './stats__stats-progress.scss';

interface OwnProps {
    stats: ProblemProgress | null;
    successTextId: string;
    failTextId?: string;
    unknownTextId: string;
    theme?: STATS_THEME;
}

interface Props extends OwnProps {}

export const StatsProgress = (props: Props) => {
    const { failTextId, stats, successTextId, unknownTextId, theme } = props;

    if (!stats) {
        return null;
    }

    const { fail, success, unknown } = stats;

    if (!fail && !success && !unknown) {
        return null;
    }

    return (
        <div className={b('stats', 'stats-progress', { theme })}>
            <ProgressLine fail={fail} mix="stats__stats-progress-line" success={success} unknown={unknown} />
            <ProgressChart mix="stats__stats-progress-bar" stats={stats} />
            <div className="stats__stats-progress-items">
                <div className={b('stats', 'stats-progress-item', { type: 'success' })}>
                    <Text color={COLORS.lessonStatText} id={successTextId} />
                    <Text>{success}</Text>
                </div>
                {failTextId && (
                    <div className={b('stats', 'stats-progress-item', { type: 'fail' })}>
                        <Text color={COLORS.lessonStatText} id={failTextId} />
                        <Text>{fail}</Text>
                    </div>
                )}
                <div className={b('stats', 'stats-progress-item', { type: 'unknown' })}>
                    <Text color={COLORS.lessonStatText} id={unknownTextId} />
                    <Text>{unknown}</Text>
                </div>
            </div>
        </div>
    );
};

StatsProgress.defaultProps = {
    theme: STATS_THEME.DEFAULT,
};

export default StatsProgress;
